import "./pages.css";
import Footer from "../Home/footer";
import Header from "../Home/header";

const Callus = () => {
  return (
    <>
      <Header />
      <div className="blg">
        <div className="headblogs">
          <div className="titlehead">
            <h2 className="h2"> Terms of Service for digital store</h2>
          </div>
        </div>
        <div className="aboutus">
          <p className="paraaboutus">
            Welcome to our platform for selling digital products. By using our
            platform, you agree to the following terms and conditions:
            Acceptance of Terms: By using our platform, you agree to be bound by
            these terms and conditions, our privacy policy, and any additional
            terms and conditions that may apply to specific features or services
            offered by our platform. Ownership: You retain all ownership rights
            to the digital products you sell through our platform. You are
            responsible for ensuring that you have the necessary rights and
            permissions to sell your products, and for any infringement or
            violation of intellectual property rights. Payment Processing: Our
            platform provides a secure and reliable payment processing system
            for your sales. We charge a transaction fee of 0% of the sale price
            for each transaction. We reserve the right to change our fees and
            pricing structure at any time, and we will provide notice of any
            changes. Delivery of Products: We will deliver your digital products
            to your customers upon receipt of payment. You are responsible for
            ensuring that your products are delivered in a timely and
            satisfactory manner. Prohibited Activities: You agree not to use our
            platform for any illegal, fraudulent, or unauthorized activities,
            including but not limited to selling counterfeit or infringing
            products, engaging in spamming or phishing activities, or engaging
            in any activity that violates these terms and conditions or
            applicable laws and regulations. Limitation of Liability: Our
            platform is provided on an "as is" and "as available" basis, without
            any warranties or representations, express or implied. We are not
            liable for any damages, including but not limited to direct,
            indirect, incidental, special, or consequential damages, arising
            from your use of our platform. Indemnification: You agree to
            indemnify and hold us harmless from any claims, damages, losses, or
            expenses arising from your use of our platform or any violation of
            these terms and conditions. Governing Law and Jurisdiction: These
            terms and conditions are governed by the laws of Products. Any
            dispute arising from your use of our platform shall be resolved in
            our us. We reserve the right to modify these terms and conditions at
            any time, and we will provide notice of any changes. If you have any
            questions or concerns, please contact us at sales@tawfikshoot.com.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Callus;
